export default __webpack_public_path__ + "webassets/cookies-plateaeff1a1375b381306ec8f7c127798e7c.png";